import { Component, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth/auth.service';
import { ModalPasswordComponent } from '@component/modal-password/modal-password.component';
import { NormalModalComponent } from '@component/normal-modal/normal-modal.component';
import { TermOperatorModalComponent } from '@component/term-operator-modal/term-operator-modal.component';
import { WorkspaceItemContentDto } from '@dto/workspace-item-content-dto';
import { WorkspaceNewSaveDto } from '@dto/workspace-new-save-dto';
import { ConnectTypeUperEnum } from '@model/enum/connect-type-user.enum';
import { LoginTypes } from '@model/enum/login-types.enum';
import { MultiBrokerTypesEnum } from '@model/enum/multi-broker-types.enum';
import { PlanFastTradeTypeEnum } from '@model/enum/plan-fasttrade-type.enum';
import { SystemServiceErrorCodKeyEnum, SystemServiceErrorEnum } from '@model/enum/system-services-error-msg';
import { WhitelabelEnum } from '@model/enum/whitelabel.enum';
import { StatusConnection } from '@model/status-connection';
import { UserCA } from '@model/wso2/userca';
import { AuthServer } from '@services/auth-server.service';
import { AuthenticationService } from '@services/authentication.service';
import { CustomSnackbarService } from '@services/custom-snackbar-service.service';
import { LayoutService } from '@services/layout.service';
import { TransitionService } from '@services/transition.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { SocketService } from '@services/webFeeder/socket.service';
import { TokenService } from '@services/webFeeder/token.service';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AppUtils } from '@utils/app.utils';
import { Constants, LOGIN_TYPE, Profile } from '@utils/constants';

import { Subscription } from 'rxjs';
import { IAMAuthService as OidcAuthService } from 'src/app/core/services/iam-auth.service';
import { LogService } from 'src/app/core/services/log.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login-broker.component.html'
})
export class LoginComponent implements OnInit, OnDestroy {

  @ViewChild('loginForm') loginForm: NgForm;
  @ViewChild('snackBar', { read: ViewContainerRef }) parent: ViewContainerRef;
  Constants = Constants;
  subscriptionStatusWebSocket: Subscription;
  dialog: MatDialog;
  whitelabel = this._configService.getConfigWhitelabel();
  tokenUrl: string;
  logoTransition = '';
  setTimeOutIp: any;
  messageStore = Constants.LOGIN_MSG_STORE;
  title = Constants.LOGIN_MSG_TITLE;
  subTitle = Constants.LOGIN_MSG_SUBTITLE;
  titleMultiBroker = Constants.LOGIN_MSG_TITLE_MULTI_BROKER;
  subTitleMultiBroker = Constants.LOGIN_MSG_SUBTITLE_MULTI_BROKER;
  titleRanking = Constants.LOGIN_MSG_TITLE_RANKING;
  subTitleRanking = Constants.LOGIN_MSG_SUBTITLE_RANKING;
  titleExpiredPassword = Constants.LOGIN_EXPIRED_PASSWORD;
  titleDoubleAuthentication = Constants.LOGIN_MSG_TITLE_AUTHENTICATION;
  errorMsg01: string = Constants.MSG03_FORGOT_ERROR;
  questionActive: any = {};
  multiBrokerTypes = Constants.MULTI_BROKER_TYPES;
  multiBrokerloginType: number;
  isRequest: boolean;
  loading: boolean;
  loadingTransition: boolean;
  loadingTransitionAdpterSSO: boolean;
  transitionStorage: any;
  model: any = {};
  isRanking: boolean;
  isUserLogged: boolean;
  messageLogout = { title: '', subTitle: '' };
  messageInputLogin = {
    inputUsername: 'Conta/Usuário', tooltipUsername: 'Número da sua conta (sem dígito) / Usuario',
    inputPassword: 'Senha', tooltipPassword: 'Senha',
    inputForgotPassword: 'Primeiro Acesso / Esqueci minha senha'
  };
  subTitleExpiredPassword = '';
  sendCodeSms: boolean;
  showResendCode: boolean;
  showDoubleAutheticationQuestion: boolean;
  showDoubleAutheticationCode: boolean;
  showMessageSSOsuccess: boolean;
  showMessageSSOerror: boolean;
  iconMessageService = 'success';
  messageServiceTitle: string;
  messageServiceDetails: string;
  showpassword: boolean;
  showExpiredPassword: boolean;
  showPasswordConfirm: boolean;
  brokeragePartners = [];
  multiBrokerSelected = [];
  listQuestionDoubleAuthentication = [];
  dataLoginDoubleAuth: any = {};
  showPasswordInvalid: boolean;
  passwordComplexyLength: boolean;
  passwordComplexySpecial: boolean;
  passwordComplexyNumber: boolean;
  passwordComplexyLetterUp: boolean;
  passwordComplexyLetterDown: boolean;
  private flag = 0;
  isMultiBroker: boolean;
  loginType = LOGIN_TYPE;
  showUrlStore: boolean;

  constructor(
    dialog: MatDialog,
    private _titleService: Title,
    private _configService: ConfigService,
    private _activatedRoute: ActivatedRoute,
    private _transitionService: TransitionService,
    private _authenticationService: AuthenticationService,
    public _snackBar: CustomSnackbarService,
    private _authServer: AuthServer,
    private _router: Router,
    private _layoutService: LayoutService,
    private _authService: AuthService,
    private _tokentService: TokenService,
    private _socketService: SocketService,
    private _workService: WorkspaceNewService,
    private renderer: Renderer2,
    private _logSvc: LogService,
    private _oidcAuthSvc: OidcAuthService,
private _domSanitizer:    DomSanitizer
  ) {
    this.dialog = dialog;
    this.getConfigWhitelabel();
    this.renderer.removeClass(document.body, 'darkTheme');
  }

async  ngOnInit() {
    if(this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginIAM){
      if(!!!this._oidcAuthSvc.isLoggedIn()){
        this._oidcAuthSvc.login()
      }
    }
    if (
      this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginA ||
      this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginW ||
      this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginIAM
    ) {
      this._activatedRoute.queryParams.subscribe(params => {
        if (this.whitelabel && this.whitelabel.system.isTransition && this.whitelabel.system.isTransition.active) {
          if(this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginIAM){

          }else{
            if (params && params.token) {
              this.tokenUrl = params ? params.token : null;
              this.model.login = params ? params.login : null;
              this._configService.writeLog('LOGIN > ngOnInit() > LoginToken: ' + this.tokenUrl + ' | login: ' + this.model.login);
            } else {
              this.transitionStorage = this._transitionService.get();
            }
          }
        }
      });
    }
    switch (this.whitelabel && this.whitelabel.system.login_type) {
      case Constants.LOGIN_TYPE.LoginS:
        this._configService.deleteCookie();
        this.loading = false;
        break;
      case Constants.LOGIN_TYPE.LoginO:
        this._configService.deleteCookie();
        this.loading = false;
        break;
      case Constants.LOGIN_TYPE.LoginIAM:

        if (this.whitelabel.system.isTransition && this.whitelabel.system.isTransition.active) { // LOGIN VIA TOKEN
          this._configService.writeLog(this.transitionStorage, 'LOGIN > ngOnInit() > transitionStorage');
          this._configService.writeLog(this.transitionStorage);
          if (
            !!this._oidcAuthSvc.isLoggedIn()
          ) {
            this.handleIAMSession();
            // this.refreshToken();
          } else {
            this._configService.REDIRECT_LOGIN();
          }
        } else {
          this._configService.deleteCookie();
          this.loading = false;
        }
        break;
      case Constants.LOGIN_TYPE.LoginW:
        if (this.whitelabel.system.isTransition && this.whitelabel.system.isTransition.active) { // LOGIN VIA TOKEN
          if (this.transitionStorage && this.transitionStorage.TKNAPIREFRESH && (this.transitionStorage.HBA_USERNAME || this.transitionStorage.SYSTEM_USERNAME)) {
            this.refreshToken();
          } else {
            this._configService.REDIRECT_LOGIN();
          }
        } else {
          this._configService.deleteCookie();
          this.loading = false;
        }
        break;
      case Constants.LOGIN_TYPE.LoginA:
        this.getAdpterInfo();
        break;
      default:
        this._configService.redirectExpireSession(null, null, SystemServiceErrorEnum.config_whitelabel, SystemServiceErrorCodKeyEnum.empty);
        break;
    }
  }

  ngOnDestroy() {
    if (this.setTimeOutIp) {
      clearInterval(this.setTimeOutIp);
    }
    if (this.subscriptionStatusWebSocket) {
      this.subscriptionStatusWebSocket.unsubscribe();
    }
  }

  getConfigWhitelabel() {
    this._configService.writeLog(this.whitelabel, 'LOGIN > getConfigWhitelabel() > whitelabel');
    if (this.whitelabel) {
      this.showUrlStore = this._configService.registerGoToIdentity() && this.whitelabel.system.cod === WhitelabelEnum.CEDRO;
      this._titleService.setTitle(this.whitelabel.system.whitelabel_name);
      this.isMultiBroker = this.whitelabel.system.isMultiBroker;
      this.logoTransition = ('./assets/images/clients/' + environment.BROKER_PATH + '/logo-workspace.'
        + this._configService.getExtensionLogo().replace('"', '').trim()).replace('"', '');
      this.loadingTransition = this.whitelabel.system.isTransition.active;
      this.isRanking = this.whitelabel.system.cod === WhitelabelEnum.RANKING ? true : false;
      this.multiBrokerloginType = this.multiBrokerTypes && this.multiBrokerTypes.length > 0 ? this.multiBrokerTypes[0].type : null;
      this.messageLogout.title = this.whitelabel.login.messageLogout.title ? this.whitelabel.login.messageLogout.title : Constants.ERROR_SYSTEM_TEXT;
      this.messageLogout.subTitle = this.whitelabel.login.messageLogout.subTitle ? this.whitelabel.login.messageLogout.subTitle : null;
      this.messageInputLogin.inputUsername = this.whitelabel.login.textInputLogin.inputUsername
        ? this.whitelabel.login.textInputLogin.inputUsername : this.messageInputLogin.inputUsername;
      this.messageInputLogin.tooltipUsername = this.whitelabel.login.textInputLogin.tooltipUsername
        ? this.whitelabel.login.textInputLogin.tooltipUsername : this.messageInputLogin.tooltipUsername;
      this.messageInputLogin.inputPassword = this.whitelabel.login.textInputLogin.inputPassword
        ? this.whitelabel.login.textInputLogin.inputPassword : this.messageInputLogin.inputPassword;
      this.messageInputLogin.tooltipPassword = this.whitelabel.login.textInputLogin.tooltipPassword
        ? this.whitelabel.login.textInputLogin.tooltipPassword : this.messageInputLogin.tooltipPassword;
      this.messageInputLogin.inputForgotPassword = this.whitelabel.login.textInputLogin.inputForgotPassword
        ? this.whitelabel.login.textInputLogin.inputForgotPassword : this.messageInputLogin.inputForgotPassword;
      this._configService.writeLog('LOGIN > getConfigWhitelabel() > WHITELABEL: [' + this.whitelabel.system.cod
        + '][' + this.whitelabel.system.whitelabel_name + '][' + this.whitelabel.system.api + ']');
    } else {
      this._configService.redirectExpireSession(null, null, SystemServiceErrorEnum.config_whitelabel, SystemServiceErrorCodKeyEnum.empty);
    }
  }

  setConfigMultiBroker() {
    if (this.multiBrokerloginType === MultiBrokerTypesEnum.BROKER && this.multiBrokerSelected) {
      this._configService.setConfigMultibroker(this.multiBrokerSelected);
      this._configService.writeLog(this.multiBrokerSelected, 'LOGIN > Broker Selecionado: ');
    }
  }

  validInputLogin() {
    if (!this.model.dinamicInput || !this.model.password) {
      this.setSnackBar();
      this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG001, Constants.ALERT_TYPE.info);
      this.loginForm.controls['password'].setErrors({ 'incorrect': true });
      this.loginForm.controls['username'].setErrors({ 'incorrect': true });
      this.isRequest = false;
      this.loading = false;
      return false;
    } else if (this.isMultiBroker && this.multiBrokerloginType === MultiBrokerTypesEnum.BROKER && this.multiBrokerSelected.length <= 0) {
      this.setSnackBar();
      this._snackBar.createSnack(this.parent, Constants.BROKER_MSG008, Constants.ALERT_TYPE.info);
      this.isRequest = false;
      this.loading = false;
      return false;
    }
    return true;
  }

  sendLogin() {
    this.loading = true;
    if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginA) {
      if (this.validInputLogin()) {
        this.sendAdapterAuthLogin(null, null, this.model.second_auth, null, this.model.dinamicInput, this.model.password);
      }
    } else if (this.showDoubleAutheticationQuestion && !this.showExpiredPassword) {
      this.answerAfcQustion();
    } else if (!this.showDoubleAutheticationQuestion && this.showExpiredPassword) {
      this.changePasswordHomeBroker();
    } else {
      if (!this.isRequest && this.validInputLogin()) {
        this.isRequest = true;
        const _user = new UserCA();
        _user.login = this.showDoubleAutheticationQuestion || this.showExpiredPassword ? this.model.login : this.model.dinamicInput.trim();
        _user.password = this.model.password.trim();
        if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginW) {
          _user.profile = isNaN(this.model.dinamicInput) ? Profile.Assessor : Profile.Client;
        }
        this._authenticationService.login({
          data: {
            username: _user.login,
            password: _user.password,
            token: this.model.second_auth,
            profile: _user.profile
          }
        })
          .subscribe((data: any) => {

            // if (data && data.accountNumber){
            //   this._sentrySvc.setUser({ accountNumber: data.accountNumber })
            //   this._logSvc.info(`Start session user`);
            // }


            if (data.code || data === 'PASSWORD_EXPIRED' || data === 'INVALID_CREDENTIALS' || data === 'INVALID_MESSAGE') {
              this.setSnackBar();
              if (data.codeMessage === 'UNAUTHORIZED') {
                if (data && (Number(data.code) === 3 || Number(data.code) === 9)) {
                  this._snackBar.createSnack(this.parent, data.message, Constants.ALERT_TYPE.info);
                  this.showExpiredPassword = true;
                  this.subTitleExpiredPassword = data.message;
                  this.model.passwordOld = this.model.password;
                  this.model.login = this.model.dinamicInput;
                  this.model.dinamicInput = '';
                  this.model.password = '';
                } else if (data.message) {
                  this._snackBar.createSnack(this.parent, data.message, Constants.ALERT_TYPE.error);
                } else {
                  this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG002, Constants.ALERT_TYPE.error);
                }
                this.loginForm.controls['password'].setErrors({ 'incorrect': true });
                this.loginForm.controls['username'].setErrors({ 'incorrect': true });
              } else {
                const messageTemp = data === 'PASSWORD_EXPIRED' ? Constants.MSG_LOGIN_MSG009 : data === 'INVALID_CREDENTIALS' ? Constants.MSG_LOGIN_MSG002 :
                  data === 'INVALID_MESSAGE' ? Constants.MSG_LOGIN_MSG010 : data.message;
                this._snackBar.createSnack(this.parent, messageTemp, Constants.ALERT_TYPE.error);
              }
              this.isRequest = false;
              this.loading = false;
              return;
            } else {
              if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginO) {
                this._configService.setTokenApi(data.token);
                this.getAfcQustion(data, _user);
              } else if (this.isRanking) {
                this.loginRanking(data, _user);
              } else {
                this.setConfigLogin(data, _user);
              }
            }
          }, () => {
            this.setSnackBar();
            this._logSvc.error(`Ocorreu um erro durante a operação para usuário ${_user.login}, verifique as informações fornecidas e tente novamente.`);
            this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
            this.isRequest = false;
            this.loading = false;
          });
      }
    }
  }

  loginRanking(data, _user) {
    this._authenticationService.brokerServiceLogin(data.accountNumber, data.accountNumber, null)
      .subscribe((res: any) => {

        if (res && res.isAuthenticated === 'N') {
          this._authenticationService.clientRegisterSimulator(data.accountNumber, data.accountNumber)
            .subscribe((resRegister: any) => {
              if (resRegister && (resRegister.success === 'true' || resRegister.success === true)) {
                setTimeout(() => {
                  this.loginRanking(data, _user);
                }, 3000);
              } else {
                this._configService.systemNotificationMessage('', Constants.BROKER_MSG012, Constants.ALERT_TYPE.error);
              }
              this.loading = false;
            });
        } else if (res && res.isAuthenticated === 'Y') {
          data.tokenWS = res.tokenNegotiation;
          this.setConfigLogin(data, _user);
        }
      });
  }

  changePasswordHomeBroker() {
    this.loading = true;
    try {
      if (this.model.dinamicInput && this.model.password && this.model.login && this.model.passwordOld) {
        this._authenticationService.difusionChangePassword(this.model.login, this.model.passwordOld, this.model.password, true)
          .subscribe(res => {
            if (res && (res.success === 'true' || res.status === true || Number(res.userStatus) === 5)) {
              this.model.dinamicInput = this.model.login;
              this.showExpiredPassword = false;
              this.sendLogin();
            } else {
              this.loading = false;
              if (res && res.message) {
                this.callAlert('', res.message, Constants.ALERT_TYPE.error);
              } else if (res && res.userStatusText) {
                this.callAlert('', res.userStatusText, Constants.ALERT_TYPE.error);
              } else if (res && (!res.success || res.success === 'false')) {
                this.callAlert('', Constants.MSG_LOGIN_MSG008, Constants.ALERT_TYPE.error);
              } else {
                this.callAlert('', Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
              }
              this.loading = false;
            }
          }, () => {
            this.callAlert('', Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
            this.loading = false;
          });
      } else {
        this.callAlert('', Constants.MSG_LOGIN_MSG001, Constants.ALERT_TYPE.warn);
        this.loading = false;
        return false;
      }
    } catch (e) {
      this.loading = false;
    }
  }

  getAfcQustion(data, _user) {
    this._authServer.iNegotiation.getAfcSearchQuestions()
      .subscribe(res => {
        if (res.code === 0 && res.questions && res.questions.length > 0) {
          this.model.questionType = '';
          this.listQuestionDoubleAuthentication = res.questions;
          const index = Math.floor(Math.random() * res.questions.length);
          this.questionActive = res.questions[index];
          this.questionActive.indexActived = [];
          this.model.dinamicInput = '';
          this.questionActive.indexActived.push(index);
          this.showDoubleAutheticationQuestion = true;
          this.dataLoginDoubleAuth = [];
          this.dataLoginDoubleAuth.push(data);
          this.dataLoginDoubleAuth.push(_user);
          this.isRequest = false;
          this.loading = false;
          this._configService.setShowStatusOms(true);
        } else {
          this._configService.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
            SystemServiceErrorEnum.afcSearchQuestions, SystemServiceErrorCodKeyEnum.empty);
        }
      }, () => {
        this.setSnackBar();
        this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
        this.isRequest = false;
        this.loading = false;
      });
  }

  answerAfcQustion() {
    this.loading = true;
    if (!this.model.dinamicInput) {
      this.setSnackBar();
      this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG001, Constants.ALERT_TYPE.info);
      this.loading = false;
      return false;
    }
    this._configService.setTokenApi(this.dataLoginDoubleAuth[0].token);
    this._authServer.iNegotiation.postAfcSearchQuestions(this.model.dinamicInput, this.questionActive.questionType)
      .subscribe(res => {
        if (res && res.code === 0 && res.success) {
          this.setConfigLogin(this.dataLoginDoubleAuth[0], this.dataLoginDoubleAuth[1]);
        } else {
          if (this.questionActive.indexActived.length === this.listQuestionDoubleAuthentication.length) {
            this._configService._authHbLogged.next(false);
            this.model = {};
            this.setSnackBar();
            this._snackBar.createSnack(this.parent, 'Resposta incorreta. Você excedeu o limite de tentativas.', Constants.ALERT_TYPE.error);
            this._configService.deleteHbBrokerUser();
            this._configService.deleteFavoriteThemeUser();
            this._configService.deleteCookie();
            this.showDoubleAutheticationQuestion = false;
            this.questionActive = {};
            this.listQuestionDoubleAuthentication = [];
            this.loading = false;
          } else {
            this.setSnackBar();
            this._snackBar.createSnack(this.parent, 'Resposta incorreta.', Constants.ALERT_TYPE.error);
            let index = Math.floor(Math.random() * this.listQuestionDoubleAuthentication.length);
            for (let i = 0; i < this.listQuestionDoubleAuthentication.length; i++) {
              for (let y = 0; y < this.questionActive.indexActived.length; y++) {
                if (index === this.questionActive.indexActived[y]) {
                  index = Math.floor(Math.random() * this.listQuestionDoubleAuthentication.length);
                  break;
                }
              }
            }
            this.questionActive.afcQuestionCode = this.listQuestionDoubleAuthentication[index].afcQuestionCode;
            this.questionActive.question = this.listQuestionDoubleAuthentication[index].question;
            this.questionActive.questionType = this.listQuestionDoubleAuthentication[index].questionType;
            this.model.dinamicInput = '';
            this.questionActive.indexActived.push(index);
            this.loading = false;
          }
        }
      }, () => {
        this.onLoginError();
        this.callAlert('', Constants.BROKER_MSG002, Constants.ALERT_TYPE.error);
      });
  }

  setFadeInAndFadeOut() {
    setTimeout(() => {
      const leftElement = document.getElementById('left-content');
      if (leftElement) {
        leftElement.classList.add('slideOutLeft');
      }
      const carouselExampleIndicators = document.getElementById('carouselExampleIndicators');
      if (carouselExampleIndicators) {
        carouselExampleIndicators.classList.add('slideOutRight');
      }
      const fullPage = document.getElementById('app-login');
      if (fullPage) {
        fullPage.classList.remove('fadeIn');
        fullPage.classList.add('fadeOut');
      }
    }, 1500);
  }

  getAdpterInfo() {
    this._authenticationService.iLogin.info()
      .subscribe(res => {
        if (res) {
          this.model.type = res.first_auth_options[0];
          if (res && res.second_auth && res.second_auth_options && res.second_auth_options.length > 0) {
            this.model.second_auth = res.second_auth;
            this.model.second_auth_options = res.second_auth_options[0];
          } else if (res && res.third_auth && res.third_auth_options.length > 0) {
            const thirdAuthTemp = { isActive: res.third_auth, type: res.third_auth_options[0] };
            this._configService.setEletronicSignatureType(thirdAuthTemp);
          }
          if (this.tokenUrl) {
            this._configService.setTokenApi(this.tokenUrl);
            this.sendAdapterAuthLogin(this.tokenUrl, this.model.login, null, null);
          } else if (this.transitionStorage) {
            this.validateTokenAdapter();
          } else if (this.model.type === 'password') {
            return;
          } else {
            this._configService.writeLog('getAdpterInfo() > ' + Constants.LOGIN_TYPE.LoginA + ' - TOKEN ou SESSAO não encontrado. ENCERRAR SESSAO.');
            this._configService.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
              SystemServiceErrorEnum.tokenOrSessionStorage, SystemServiceErrorCodKeyEnum.empty);
          }
        } else {
          this._configService.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
            SystemServiceErrorEnum.info, SystemServiceErrorCodKeyEnum.error);
        }
      }, error => {
        const error_message = error && error.error && error.error.error_message ? error.error.error_message : this.messageLogout.title;
        this._configService.redirectExpireSession(error_message, this.messageLogout.subTitle,
          SystemServiceErrorEnum.info, SystemServiceErrorCodKeyEnum.error);
      });
  }



  sendAdapterAuthLogin(code: string, login: any, second_auth_option: string, answer: string, username?: string, password?: string) {
    this.loadingTransitionAdpterSSO = true;
    this._authenticationService.iLogin.loginAuth(code, login, second_auth_option, answer, username, password)
      .subscribe(res => {
        if (this.model.type === 'password' && !answer && (res.error === 'false' || res.error === false) && res.token) {
          this.showDoubleAutheticationCode = true;
          this.tokenUrl = res.token;
          this._configService.setTokenApi(res.token);
          this.loading = false;
          this.isRequest = false;
        } else if (code && res && (res.error === 'false' || res.error === false) && res.token) { // Login Token
          this.tokenUrl = res.token;
          this.model.token = res.token;
          this._configService.setTokenApi(res.token);
          this._configService.setTokenTp(res.token_type);
          if (this.model.second_auth && this.model.second_auth_options) {
            this.sendCodeSms = this.model.second_auth_options === 'sms' ? true : false;
            this.sendAdapterAuthLogin(null, login, this.model.second_auth_options, null);
          } else {
            const _user = new UserCA();
            _user.name = res.login;
            const user = { username: _user.name, firstName: 'NA', lastName: 'NA' };
            this._configService.setHbCurrentUser(user);
            this.setConfigLogin(res, _user);
          }
        } else if (second_auth_option && res && (res.error === 'false' || res.error === false)) { // Send SMS or EMAIL
          this.showDoubleAutheticationCode = true;
          const smsOrEmail = this.sendCodeSms ? 'por SMS' : 'para o E-mail';
          this.showMessageLoginAuthSSO(true, false, Constants.MSG_LOGIN_MSG016.replace('[BROKER]', this.whitelabel.system.whitelabel_name),
            Constants.MSG_LOGIN_MSG016.replace('[SMS_OR_EMAIL]', smsOrEmail));
          setTimeout(() => { // espera 60 segundos pro botao aparecer
            this.showResendCode = true;
          }, 15000);
        } else if (answer && res && (res.error === 'false' || res.error === false) && this.tokenUrl) { // Answer
          const _user = new UserCA();
          _user.name = res.login;
          if (this.model.dinamicInput) {
            _user.login = res.login;
          }
          const user = { username: _user.name, firstName: 'NA', lastName: 'NA' };
          this._configService.setHbCurrentUser(user);
          this.setConfigLogin(res, _user);
        } else {
          let error_message = '';
          let subTitle = '';
          if (code) {
            error_message = Constants.MSG07_FORGOT_ERROR;
            subTitle = Constants.MSG07_FORGOT_ERROR_SUBTITLE;
          } else if (second_auth_option && this.model.type !== 'password') {
            error_message = Constants.MSG_LOGIN_MSG016.replace('[BROKER]', this.whitelabel.system.whitelabel_name);
          } else if (answer) {
            error_message = Constants.MSG_LOGIN_MSG014.replace('[BROKER]', this.whitelabel.system.whitelabel_name);
            subTitle = Constants.MSG_LOGIN_MSG014.replace('[BROKER]', this.whitelabel.system.whitelabel_name);
          } else if (this.model.type === 'password' && res.error) {
            this.setSnackBar();
            this._snackBar.createSnack(this.parent, res.error_message, Constants.ALERT_TYPE.error);
            this.loginForm.controls['password'].setErrors({ 'incorrect': true });
            this.loginForm.controls['username'].setErrors({ 'incorrect': true });
            this.isRequest = false;
            this.loading = false;
            return false;
          }
          this.showMessageLoginAuthSSO(false, true, error_message, subTitle);
        }
        this.loadingTransitionAdpterSSO = false;
      }, error => {
        const error_message = error && error.error && error.error.error_message ? error.error.error_message : this.messageLogout.title;
        this._configService.redirectExpireSession(error_message, this.messageLogout.subTitle,
          SystemServiceErrorEnum.info, SystemServiceErrorCodKeyEnum.error);
      });
  }

  validDoubleSSO() {
    if (!this.loadingTransitionAdpterSSO) {
      if (!this.model.numberAuthOne || !this.model.numberAuthTwo || !this.model.numberAuthThree ||
        !this.model.numberAuthFour || !this.model.numberAuthFive || !this.model.numberAuthSix) {
        this.showMessageLoginAuthSSO(false, true, Constants.MSG_LOGIN_MSG019, Constants.MSG_LOGIN_MSG001);
        const listInvalid = [];
        if (!this.model.numberAuthOne) {
          this.model.numberAuthOne = '';
          listInvalid.push(1);
        }
        if (!this.model.numberAuthTwo) {
          this.model.numberAuthTwo = '';
          listInvalid.push(2);
        }
        if (!this.model.numberAuthThree) {
          this.model.numberAuthThree = '';
          listInvalid.push(3);
        }
        if (!this.model.numberAuthFour) {
          this.model.numberAuthFour = '';
          listInvalid.push(4);
        }
        if (!this.model.numberAuthFive) {
          this.model.numberAuthFive = '';
          listInvalid.push(5);
        }
        if (!this.model.numberAuthSix) {
          this.model.numberAuthSix = '';
          listInvalid.push(6);
        }
        if (listInvalid && listInvalid.length > 0) {
          let qtd = 0;
          listInvalid.forEach(element => {
            const nextInput = document.getElementById('input-' + (element + 1));
            if (nextInput) {
              setTimeout(() => {
                nextInput.focus();
                qtd++;
                if (qtd >= listInvalid.length - 1) {
                  const lastFocus = document.getElementById('input-' + (listInvalid[0]));
                  setTimeout(() => {
                    lastFocus.focus();
                  }, 0);
                }
              }, 0);
            }
          });
        }
      } else {
        this.showMessageSSOsuccess = false;
        this.showMessageSSOerror = false;
        const answer = this.model.numberAuthOne + this.model.numberAuthTwo + this.model.numberAuthThree
          + this.model.numberAuthFour + this.model.numberAuthFive + this.model.numberAuthSix;
        this.sendAdapterAuthLogin(null, null, null, answer);
      }
    }
  }

  backSpaceInputDoubleSSO(id: number) {
    if (id === 1) {
      this.model.numberAuthOne = null;
    } else if (id === 2) {
      this.model.numberAuthTwo = null;
    } else if (id === 3) {
      this.model.numberAuthThree = null;
    } else if (id === 4) {
      this.model.numberAuthFour = null;
    } else if (id === 5) {
      this.model.numberAuthFive = null;
    } else if (id === 6) {
      this.model.numberAuthSix = null;
    }
  }

  resendSmsOrEmail(code: string) {
    if (!this.loadingTransitionAdpterSSO) {
      this.loadingTransitionAdpterSSO = true;
      this.sendCodeSms = code === 'sms' ? true : false;
      this.sendAdapterAuthLogin(null, null, code, null);
    }
  }

  showMessageLoginAuthSSO(showMessageSSOsuccess: boolean, showMessageSSOerror: boolean, messageServiceTitle: string, messageServiceDetails: string) {
    if (showMessageSSOsuccess) {
      this.iconMessageService = 'success';
      this.showMessageSSOsuccess = showMessageSSOsuccess;
    } else if (showMessageSSOerror) {
      this.iconMessageService = 'danger';
      this.showMessageSSOerror = showMessageSSOerror;
    }
    this.messageServiceTitle = messageServiceTitle;
    this.messageServiceDetails = messageServiceDetails;
    setTimeout(() => {
      this.showMessageSSOsuccess = false;
      this.showMessageSSOerror = false;
    }, 5000);
  }

  refreshToken() {
    if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginA) {
      this._configService.setTokenRefreshApi(this.transitionStorage.refresh_token);
    } else {
      this._configService.setTokenRefreshApi(this.transitionStorage?.TKNAPIREFRESH);
    }
    console.log(this._authenticationService)
    this._authenticationService.iAuthStrategy.refresh()
      .subscribe(async (dataRefresh) => {
        console.log('_authenticationService.iAuthStrategy.refresh()')
        console.log(dataRefresh)
        if (dataRefresh) {
          // this.transitionStorage.refresh_token = dataRefresh.refresh_token;
          // this.transitionStorage.token = dataRefresh.token;
          if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginA) {
            const _user = new UserCA();
            _user.name = this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginA ? this.transitionStorage.login : this.transitionStorage.SYSTEM_USERNAME;
            const user = { username: _user.name, firstName: 'NA', lastName: 'NA' };
            this._configService.setHbCurrentUser(user);
            this.transitionStorage.user_identifier = dataRefresh.user_identifier;
            this.setConfigLogin(this.transitionStorage, _user);
          } else if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginW) {
            this._configService.setHbCurrentUser(this.transitionStorage.HBA_CURRENT_USER);
            this.setConfigLogin(this.transitionStorage, null);
          } else if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginIAM) {
            let user = await this._authenticationService.iAuthStrategy.getCurrentUser()
            this._configService.setHbCurrentUser(user.info.preferred_username);
            console.log(user.info.preferred_username)
            this.setConfigLogin({...user.info, ...dataRefresh}, null);
          }
        } else {
          this._configService.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
            SystemServiceErrorEnum.refresh_token, SystemServiceErrorCodKeyEnum.error);
        }
      }, error => {
        const error_message = error.error_message ? error.error_message : this.messageLogout.title;
        this._configService.redirectExpireSession(error_message || this.messageLogout.title, this.messageLogout.subTitle,
          SystemServiceErrorEnum.refresh_token, SystemServiceErrorCodKeyEnum.error);
      });
  }

  validateTokenAdapter() {
    this._configService.setTokenApi(this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginA ? this.transitionStorage.token : this.transitionStorage.TKNAPI);
    this._authenticationService.iLogin.validateTokenAdapter()
      .subscribe(res => {
        if (res && !res.error && res.login === this.transitionStorage.login) {
          const _user = new UserCA();
          _user.name = this.transitionStorage.login;
          const user = { username: _user.name, firstName: 'NA', lastName: 'NA' };
          this._configService.setHbCurrentUser(user);
          this.setConfigLogin(this.transitionStorage, _user);
        } else {
          this._configService.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
            SystemServiceErrorEnum.validate_token, SystemServiceErrorCodKeyEnum.error);
        }
      }, error => {
        const error_message = error.error_message ? error.error_message : this.messageLogout.title;
        this._configService.redirectExpireSession(error_message || this.messageLogout.title, this.messageLogout.subTitle,
          SystemServiceErrorEnum.validate_token, SystemServiceErrorCodKeyEnum.error);
      });
  }

    async handleIAMSession() {
    try {
      let {info} = await this._authenticationService.iLogin.info();
       // .subscribe(res => {
        if (info) {
          if (this.tokenUrl) {
            this._configService.setTokenApi(this.tokenUrl);
            this.sendAdapterAuthLogin(this.tokenUrl, this.model.login, null, null);
          } else {

            let response = await this._authenticationService.refresh().toPromise()

            this.tokenUrl = this._authenticationService.iAuthStrategy.getTokenApi();
            this.model.token = this._authenticationService.iAuthStrategy.getTokenApi();
            this._configService.setTokenApi(this._authenticationService.iAuthStrategy.getTokenApi());
            this._configService.setTokenTp(info.token_type);

            const _user = new UserCA();
            _user.login = info.preferred_username;
            _user.name = info.preferred_username;
            const user = { username: _user.name, firstName: 'NA', lastName: 'NA' };
            this._configService.setHbCurrentUser(user);
            this.setConfigLogin({...info, ...response}, _user);

            return;
          }
            this._configService.writeLog('getAdpterInfo() > ' + Constants.LOGIN_TYPE.LoginIAM + ' - TOKEN ou SESSAO não encontrado. ENCERRAR SESSAO.');
            this._configService.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
              SystemServiceErrorEnum.tokenOrSessionStorage, SystemServiceErrorCodKeyEnum.empty);

        } else {
          this._configService.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
            SystemServiceErrorEnum.info, SystemServiceErrorCodKeyEnum.error);
        }
      // }, error => {
      // });
    } catch (error) {
      console.log(error)
      const error_message = error && error.error && error.error.error_message ? error.error.error_message : this.messageLogout.title;
      this._configService.redirectExpireSession(error_message, this.messageLogout.subTitle,
        SystemServiceErrorEnum.info, SystemServiceErrorCodKeyEnum.error);
    }
  }


async setConfigLogin(data: any, _user: UserCA) {
    if (data) {
      let typeLoginHB;
      const themeDarkCookie = this._configService.getFavoriteThemeUser();
      if (themeDarkCookie) {
        this._configService.setFavoriteThemeUser(themeDarkCookie.toString());
        this._layoutService.setDarkTheme();
      } else {
        this._configService.setFavoriteThemeUser(this.whitelabel.system.isThemeDarkDefault);
        this._layoutService.setLightTheme();
      }
      this._configService.deleteHba();
      this._configService.setHbLoginTypeEnable(this.whitelabel.system.login_type);
      this._configService.setTokenTp(data.token_type);
      this._configService.setTokenLastRefreshed(AppUtils.getDateTimeLocaleFormat(new Date((new Date()).getTime())));
      if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginIAM) { // IAM

        console.log(data)

        this.transitionStorage = {
              ...this.transitionStorage,
              HBA: data?.sub,
              HBA_CURRENT_USER: {
                  username: data?.sub,
                  firstName: data?.name,
                  lastName: ""
              },
              HBA_EMAIL: data?.email,
              HB_BROKER: data?.sub,
              TKNAPI: data?.access_token,
              TKNEXP: data?.exp,
              // TKNWF: data?.access_token,
              // TKNWF_GRAPHIC: data?.access_token,
              TKNAPIREFRESH: data?.refresh_token,
              TKN_NEGOT: data?.access_token,
              SYSTEM_USERNAME: "",
              HBA_ASSESSOR_ID: "",
              HBA_ID: "",
              HBA_USER_ID: "",
              HBA_USERNAME: "",
              HB_LOGIN_TYPE: "",
              HB_LOGIN_TYPE_ENABLED: "",
              USER_LOGIN_TYPE: "",
              LAYOUT_THEME_DARK: "",
              IS_ASSESSOR: "",
              CLIENT_PROFILE_NAME: "",
            };

            let result:any = await this._authenticationService.getWStoken().toPromise();
            let result2:any = await this._authenticationService.getWStoken().toPromise();
            this.transitionStorage.TKNWF  = result.token;
            this.transitionStorage.TKNWF_GRAPHIC  =result2.token;

            console.log(this.transitionStorage)

            typeLoginHB = ConnectTypeUperEnum.HB_TYPE_CEDRO.toString();
            if (_user && _user.login) {
              this._authService.setUserLogged(_user && _user.login.split(/\s+/)[0]);
            }

            this._configService.setBrokerAccount(data.preferred_username, typeLoginHB);

            this._configService.setTokenApi(data?.access_token);
            this._configService.setToken(result.token);
            this._configService.setHbAccount(data.preferred_username);
            this._configService.setTokenRefreshApi(data?.refresh_token);
            this._configService.setUserIdentifier(data?.access_token);
            this._configService.setTokenGraphic(result2.token);
            this._configService.setTimerTokenExpiration(data.expires_in);
            this._configService.setTokenExpiration(AppUtils.getDateTimeLocaleFormat(new Date((new Date()).getTime() + data.expires_in)));
            // this._transitionService.clear();

      } else if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginW) { // WSO2
        if (this.whitelabel.system.isTransition.active && this.transitionStorage) { // TRANSIÇÃO
          typeLoginHB = this.transitionStorage.HB_LOGIN_TYPE;
          this._configService.setAdisorGestorCanAcceptTerm(this.transitionStorage.ADVISOR_GESTOR_CAN_ACCEPT_TERM);
          this._configService.setHbAccount(this.transitionStorage.HBA.toString());
          this._configService.setBrokerAccount(this.transitionStorage.HBA.toString(), typeLoginHB);
          this._configService.setBrokerAccountSelectedTransition(this.transitionStorage.HB_BROKER_SELECT);
          this._configService.setBrokerAccountSelected(this.transitionStorage.HB_BROKER_SELECT, false);
          this._tokentService.sendStatus(true);
          this._configService.setUserSystemLogged(this.transitionStorage.SYSTEM_USERNAME);
          this._authService.setUserLogged(this.transitionStorage.HBA_USERNAME ? this.transitionStorage.HBA_USERNAME.split(/\s+/)[0] : this.transitionStorage.HBA_USERNAME);
          if (this.transitionStorage.IS_ASSESSOR) {
            this._configService.setUserLoginType(Profile.Assessor);
            this._configService.setAssessorId(this.transitionStorage.HBA_ASSESSOR_ID);
            const clientSelected = JSON.parse(this.transitionStorage.ASSESSOR_CLIENT_SELECTED);
            if (clientSelected) {
              this._configService.setAssessorClientSelected(clientSelected);
            }
          } else {
            this._configService.setUserLoginType(Profile.Client);
            this._configService.setHbAccountId(this.transitionStorage.HBA_ID);
            this._configService.setHbEmail(this.transitionStorage.HBA_EMAIL);
            this._configService.setProfileName(this.transitionStorage.CLIENT_PROFILE_NAME);
            this._configService.setHbUserId(this.transitionStorage.HBA_USER_ID);
            this._configService.setHbAccountName(this.transitionStorage.HBA_USERNAME);
          }
        } else { // Login
          this._configService.setToken(data.access_token);
          this._configService.setTokenApi(data.access_token);
          this._configService.setTokenGraphic(data.access_token);
          this._configService.setTokenRefreshApi(data.refresh_token);
          this._configService.setScope(data.scope);
          this._configService.setTokenExpiration(AppUtils.getDateTimeLocaleFormat(new Date((new Date()).getTime() + (data.expires_in * 1000))));
          this._configService.setIsAssessor(data.assessor ? Profile.Assessor : Profile.Client);
          this._configService.setUserLoginType(data.assessor ? Profile.Assessor : Profile.Client);
          if (data.client) {
            typeLoginHB = ConnectTypeUperEnum.HB_TYPE_CEDRO.toString();
            if (data.client && data.client.selectedAccount && data.client.selectedAccount.account && data.client.selectedAccount.account.account) {
              this._configService.setHbAccount(data.client.selectedAccount.account.account);
            }
            this._configService.setHbUserId(data.client.user_id);
            this._configService.setHbAccountId(data.client.id);
            this._configService.setHbAccountName(data.client.name);
            this._configService.setHbEmail(data.client.email);
            this._authService.setUserLogged(_user && _user.login ? _user.login.split(/\s+/)[0] : _user.login);
            this._configService.setUserSystemLogged(_user && _user.login ? _user.login.split(/\s+/)[0] : '');
          } else if (data.assessor) {
            typeLoginHB = ConnectTypeUperEnum.HB_TYPE_ASSESSOR.toString();
            this._configService.setHbAccount(data.assessor.login);
            this._configService.setAssessorId(data.assessor.id);
            this._configService.setIsAssessor(Profile.Assessor);
            this._authService.setUserLogged(data.assessor ? data.assessor.name.split(/\s+/)[0] : data.assessor);
            this._configService.setUserSystemLogged(data.assessor ? data.assessor.name.split(/\s+/)[0] : data.assessor);
          }
          this._configService.setBrokerAccount(this._configService.getHbAccount(), typeLoginHB);
        }
      } else if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginA) {
        typeLoginHB = ConnectTypeUperEnum.HB_TYPE_CEDRO.toString();
        if (_user && _user.login) {
          this._authService.setUserLogged(_user && _user.login.split(/\s+/)[0]);
        }
        if (data.default_account) {
          data.accountNumber = data.default_account;
          this._configService.setBrokerAccountSelected(data.default_account);
        } else {
          if (data.account && data.account.length > 0 && data.account[0].indexOf(',') !== -1) {
            data.accountNumber = data.account[0].split(',')[0];
          }
          if (data.account && data.account.length >= 1) {
            data.accountNumber = data.account[0];
          }
        }
        if (!data.accountNumber || (data.accountNumber && data.accountNumber.length <= 0)) {
          this._configService.setBrokerAccount('[]', Constants.COOKIE_HB_TYPE_MARKET_DATA);
        } else if (this.model.type === 'password') {
          this._configService.setBrokerAccount(data.login, typeLoginHB);
        } else {
          this._configService.setBrokerAccount(data.accountNumber, typeLoginHB);
        }
        this._configService.setTokenApi(data.token);
        this._configService.setToken(data.ws_token);
        this._configService.setHbAccount(data.login);
        this._configService.setTokenRefreshApi(data.refresh_token);
        this._configService.setUserIdentifier(data.user_identifier);
        this._configService.setTokenGraphic(data.ws_token);
        this._configService.setTimerTokenExpiration(data.expires_in);
        this._configService.setTokenExpiration(AppUtils.getDateTimeLocaleFormat(new Date((new Date()).getTime() + data.expires_in)));
        this._transitionService.clear();
      } else {
        if (this.isRanking) {
          this._configService.setHbLoginTypeEnable(Constants.LOGIN_TYPE.LoginO);
          typeLoginHB = ConnectTypeUperEnum.HB_TYPE_CEDRO.toString();
          this._configService.setBrokerAccount(data.accountNumber, typeLoginHB);
        } else if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginS) {
          if (!this.isMultiBroker) {
            this.setFadeInAndFadeOut();
          }
          typeLoginHB = ConnectTypeUperEnum.HB_TYPE_OFFILINE.toString();
          this._configService.setBrokerAccount(null, typeLoginHB);
        } else if (this.whitelabel.system.login_type === Constants.LOGIN_TYPE.LoginO) {
          typeLoginHB = ConnectTypeUperEnum.HB_TYPE_CEDRO.toString();
          this._configService.setBrokerAccount(data.accountNumber, typeLoginHB);
        }
        this._configService.setTokenApi(data.token);
        this._configService.setToken(data.tokenWS);
        this._configService.setTokenGraphic(data.tokenWsGraphic);
        this._configService.setTokenRefreshApi(data.refresh_token);
        this._configService.setHbAccount(data.accountNumber);
        this._configService.setTokenLastRefreshed(AppUtils.getDateTimeLocaleFormat(new Date((new Date()).getTime())));
        this._configService.setTimerTokenExpiration(data.expires_in);
        this._configService.setTokenExpiration(AppUtils.getDateTimeLocaleFormat(new Date((new Date()).getTime() + data.expires_in)));
        this._configService.setGuidUser(data.guidUser);
        this._authService.setUserLogged(data.accountNumber);
        this._configService.setShowStatusOms(false);
        this._configService.setHba(this._configService.getGuidUser(), '0');
        this._tokentService.sendStatus(true);
      }
      if (this.whitelabel.system.isMultiBroker && !this.isRanking) {
        this._configService.setUserMarketData(_user.login, _user.password, data.token);
      }
      this._configService._authHbLoginType.next(Number(typeLoginHB));
      this._configService._authHbLogged.next((!data.accountNumber || (data.accountNumber && data.accountNumber.length <= 0)) ? false : true);
      this.isUserLogged = true;
      this._tokentService.assignServices();
      if (this.whitelabel.system.getSystemTermUse) {
        this.getTermsUse();
      } else {
        if (this.whitelabel.system.isMultiBroker && !this.isRanking) {
          this.getContextInfoUser(_user.login, _user.password);
        } else {
          this.redirectToHome();
        }
      }
    }
  }

  getContextInfoUser(login, password) {
    if (login && password) {
      // let observable = this._authServer.iCedroServices.contextInfoUser(login, password);
      this._authServer.iCedroServices.contextInfoUser(login, password)
        .subscribe(async (res: any) => {
          res = await res;

          if (res && res.shadow && res.shadow.shadowLogin === login) {
            const expirationDaysTemp = res.permissions.softwares.length > 0 ? res.permissions.softwares.find((x: any) => x.softwareKey === 'ftcedro') : null;
            const expirationDaysRemaining = expirationDaysTemp && expirationDaysTemp.expirationDays >= 0 ?
              (expirationDaysTemp.expirationDays === 0 ? 1 : expirationDaysTemp.expirationDays) : null;
            if (Number(res.shadow.shadowDemo) > 0 && (Number(res.shadow.shadowActive) < 1 || expirationDaysRemaining < 0)) {
              const planUser: any = Constants.PLAN_FAST_TRADE_TYPE.find((x: any) => x.id === PlanFastTradeTypeEnum.DEMO_INATIVE);
              planUser.message = planUser.message.replace('[USERNAME]', res.shadow.shadowName);
              planUser.detail = planUser.detail.replace('[USERNAME]', res.shadow.shadowName);
              this._authServer.iCedroServices.clearContextInfoUser();
              const modalOrders = this.dialog.open(NormalModalComponent, {
                data: {
                  title: planUser.title,
                  body: planUser.detail,
                  btnConfirmText: planUser.btnConfirmText,
                  btnCancelText: planUser.btnCancelText
                },
                panelClass: 'mat-modal-normal', maxWidth: '530px'
              });
              if (modalOrders) {
                modalOrders.afterClosed().subscribe(result => {
                  if (result) {
                    window.open(this._configService.getUserStore(), '_blank');
                  }
                });
              }
              this.isRequest = false;
              this.loading = false;
            } else {
              this.redirectToHome();
            }
          } else {
            this.isRequest = false;
            this.loading = false;
          }
        });
    }
  }

  redirectToHome() {
    let alreadyConnected = false;
    const { showAfterLoginMessage } = this.whitelabel.system;
    this._configService.setAfterLoginMessage(String(showAfterLoginMessage));

    this.subscriptionStatusWebSocket = this._socketService.statusWebSocket$.subscribe(status => {

      if (status === StatusConnection.SUCCESS && !alreadyConnected) {
        alreadyConnected = true;
        this._workService.existsWorkspace().then(res => {
          console.log(res)
          this._configService.writeLog(res, 'LOGIN > redirectToHome() > existsWorkspace() > res:');
          if (res) {
            this._configService.setFirstLoginModalNotification('false');
            this._router.navigate(['home']);
          } else {
            this._workService.loadPredefinedWorkspaces().subscribe(wksDefault => {
              this._configService.writeLog(wksDefault, 'LOGIN > redirectToHome() > wksDefault: ');
              let JsonDataArr;
              let isWksOffline = false;
              if (wksDefault && wksDefault.length > 0) {
                wksDefault.forEach(element => {
                  if (!isWksOffline) {
                    if (element.JsonData.indexOf(Constants.WKS_USER_NAME_DEFAULT_PROFILE) > 0) {
                      JsonDataArr = JSON.parse(element.JsonData);
                      this._configService.writeLog(JsonDataArr, 'LOGIN > redirectToHome() > Carrega Workspace ONLINE: ');
                    }
                  }
                });
              } else {
                JsonDataArr = JSON.parse(Constants.OFFLINE_DEFAULT_WORKSPACE[0].JsonData);
                this._configService.writeLog(JsonDataArr, 'LOGIN > redirectToHome() > Carrega Workspace OFFLINE: ');
                isWksOffline = true;
              }
              if (JsonDataArr) {
                const content: Array<WorkspaceItemContentDto> = this._workService.convertDtoContenToSave(JsonDataArr);
                const wksDtoSave: WorkspaceNewSaveDto = new WorkspaceNewSaveDto(Constants.WKS_USER_NAME_DEFAULT_PROFILE, content, 0);
                this._workService.addWks(wksDtoSave)
                  .subscribe(data => {
                    this._configService.writeLog(wksDtoSave, 'LOGIN > redirectToHome() > addWks() > Workspace Criado: ');
                    if (data) {
                      this._router.navigate(['home']);
                    } else {
                      this._configService.writeLog(JsonDataArr, 'LOGIN > redirectToHome() > Falha no serviço para criar o workspace do usuario');
                      this._configService.redirectExpireSession(this.messageLogout.title || Constants.ERROR_SYSTEM_TEXT,
                        this.messageLogout.subTitle, SystemServiceErrorEnum.addWks, SystemServiceErrorCodKeyEnum.error);
                    }
                  });
              } else {
                this._configService.writeLog(JsonDataArr, 'LOGIN > redirectToHome() > Falha no serviço para criar o workspace do usuario');
                this._configService.redirectExpireSession(this.messageLogout.title || Constants.ERROR_SYSTEM_TEXT,
                  this.messageLogout.subTitle, SystemServiceErrorEnum.addWks, SystemServiceErrorCodKeyEnum.error);
              }
            }, () => {
              this._configService.redirectExpireSession(Constants.ERROR_SYSTEM_TEXT);
            });
            return false;
          }
          this.loading = false;
        });
      }
    });
  }

  onLoginError() {
    this.model = {};
    this._configService._authHbLogged.next(false);
    this._configService.deleteHbBrokerUser();
    this._configService.deleteAllCookie();
    this.showDoubleAutheticationCode = false;
    this.showDoubleAutheticationQuestion = false;
    this.questionActive = {};
    this.isRequest = false;
    this.loading = false;
  }

  createAccount() {
    this._router.navigate([this.isRanking ? Constants.CREATE_NEW_ACCOUNT_RANKING : Constants.CREATE_NEW_ACCOUNT_API]);
  }

  openStore() {
    window.open(this._configService.getUserStore(), '_blank');
  }

  forgotPassword() {
    if (this.whitelabel.login.textInputLogin.linkForgotPassword || environment.FORGOT_PASSWORD_URL) {
      let linkForgot = this.whitelabel.login.textInputLogin.linkForgotPassword ? this.whitelabel.login.textInputLogin.linkForgotPassword : environment.FORGOT_PASSWORD_URL;
      if(environment.INCLUDE_ORIGIN_IN_FORGOT_URL){
        linkForgot = `${linkForgot}?clientLoginUrl=${window.location.href}`
      }
      window.open(linkForgot);
    } else {
      this.dialog.open(ModalPasswordComponent, {
        data: {
          title: Constants.MSG01_FORGOT_TITLE,
          content: Constants.MSG01_FORGOT_CONTENT,
        },
        panelClass: Constants.NORMAL_MODAL,
        width: '590px', height: '315px'
      });
    }
  }

  openWhatsappWindow() {
    if (this.whitelabel && this.whitelabel.contact.supportPhone && this.whitelabel.contact.supportPhone.isWhatsApp) {
      let whatappNumber = this.whitelabel.contact.supportPhone.phoneNumber.replace(/[^\d]/g, '')
      window.open(Constants.SIDEBAR_HELP_WHATSAPP_LINK + whatappNumber, '_blank');
    }
  }

  get whatsAppNumber(){
    if (this.whitelabel && this.whitelabel.contact.supportPhone && this.whitelabel.contact.supportPhone.isWhatsApp) {
      return this._domSanitizer.bypassSecurityTrustUrl(Constants.SIDEBAR_HELP_WHATSAPP_LINK.replace('{{phone}}',this.whitelabel.contact.supportPhone.phoneNumber.replace(/[^\d]/g, '')))
    }
    return ''
  }

  openHb() {
    if (this.whitelabel.contact.urlHbWhitelabel) {
      window.open(this.whitelabel.contact.urlHbWhitelabel);
    }
  }

  openLinkCvm() {
    window.open(Constants.LINK_POLICY_CVM);
  }

  openLinkBmfBovespa() {
    window.open(Constants.LINK_POLICY_BMF_BOVESPA);
  }

  openRanking() {
    window.open(Constants.LINK_URL_RANKED);
  }

  togglePassword() {
    this.showpassword = !this.showpassword;
  }

  togglePasswordConfirm() {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  validChar(e) {
    if (AppUtils.validCharSystem(e)) {
      this.callAlert('', 'Caracter (' + e.key + ') inválido.', Constants.ALERT_TYPE.warn);
      return false;
    }
  }

  validatePastedString(event: ClipboardEvent) {
    event.stopPropagation();
    event.preventDefault();

    const clipboardData = event.clipboardData;
    const pastedString = clipboardData && clipboardData.getData('Text');
    if (!pastedString) {
      return;
    }

    let isValidString = true;
    let invalidCharCount = 0;
    for (let i = 0; i < pastedString.length; i++) {
      const char = pastedString[i];
      const isForbiddenChar = AppUtils.validCharSystem({ key: char });
      if (isForbiddenChar) {
        setTimeout(() => {
          this.callAlert('', 'Caracter (' + char + ') inválido.', Constants.ALERT_TYPE.warn);
        }, invalidCharCount * 300);
        isValidString = false;
        invalidCharCount++;
      }
    }

    if (isValidString) {
      this.model.password = pastedString;
    }

  }

  resetValidity(value) {
    if (value.key !== 'Enter') {
      let valueBefore = this.loginForm.controls['username'].value;
      this.loginForm.controls['username'].setValue(valueBefore);
      valueBefore = this.loginForm.controls['password'].value;
      this.loginForm.controls['password'].setValue(valueBefore);
      const snackDiv = document.getElementById('snack-bar-msg');
      snackDiv.classList.remove('active');
      snackDiv.style.display = 'hidden';
    }
  }

  validatorPassword() {
    if (!this.showDoubleAutheticationQuestion && this.showExpiredPassword) {
      if (this.model.dinamicInput !== this.model.password) {
        this.showPasswordInvalid = true;
      } else {
        this.showPasswordInvalid = false;
      }
    }
  }

  validatorPassword2(value) {
    if (!this.showDoubleAutheticationQuestion && this.showExpiredPassword) {
      if (this.model.password) {
        if (this.model.dinamicInput !== this.model.password) {
          this.showPasswordInvalid = true;
        } else {
          this.showPasswordInvalid = false;
        }
      }
      if (value) {
        this.complexyPassoword(value);
      } else {
        this.passwordComplexyLength = false;
        this.passwordComplexyNumber = false;
        this.passwordComplexySpecial = false;
        this.passwordComplexyLetterUp = false;
        this.passwordComplexyLetterDown = false;
      }
    }
  }

  complexyPassoword(value) {
    if (value && value !== '') {
      const passwordComplexyLengthTemp = new RegExp('^(?=.{8,})').test(value);
      const passwordComplexySpecialTemp = new RegExp('^(?=.*[#$^+=!*()@%&])').test(value);
      const passwordComplexyNumberTemp = new RegExp('^(?=.*[0-9])').test(value);
      const passwordComplexyLetterUpTemp = new RegExp('^(?=.*[A-Z])').test(value);
      const passwordComplexyLetterDownTemp = new RegExp('^(?=.*[a-z])').test(value);
      this.passwordComplexyLength = passwordComplexyLengthTemp ? true : false;
      this.passwordComplexySpecial = passwordComplexySpecialTemp ? true : false;
      this.passwordComplexyNumber = passwordComplexyNumberTemp ? true : false;
      this.passwordComplexyLetterUp = passwordComplexyLetterUpTemp ? true : false;
      this.passwordComplexyLetterDown = passwordComplexyLetterDownTemp ? true : false;
    }
  }

  keyPressed(event: any) {
    if (event) {
      const inputChar = event.keyCode;
      const elementId = event.srcElement.id;
      const elementStrArray = elementId.split('-');
      const inputId = elementStrArray ? +elementStrArray[elementStrArray.length - 1] : null;
      const numberPattern = /^\d+$/;
      if (inputChar === 13) { // ENTER
        this.validDoubleSSO();
      } else if (inputChar === 8) { // DELETE
        event.preventDefault();
        if (inputId) {
          (<HTMLInputElement>document.getElementById('input-' + (inputId))).value = '';
          this.backSpaceInputDoubleSSO(Number((inputId)));
          const nextInput = document.getElementById('input-' + (inputId - 1));
          if (nextInput) {
            setTimeout(() => {
              nextInput.focus();
            }, 0);
          }
        }
      } else { // INSERT
        this.flag++;
        if (this.flag > 8) {
          event.preventDefault();
          this.model.numberAuthOne = 0;
        }
        if (!numberPattern.test(inputChar)) {
          event.preventDefault();
        } else {
          if (inputId) {
            const nextInput = document.getElementById('input-' + (inputId + 1));
            if (nextInput) {
              setTimeout(() => {
                nextInput.focus();
              }, 0);
            }
          }
        }
      }
    }
  }

  keyUpped() {
    this.flag = 0;
  }

  showSnackBarTip(type: number) {
    const element = document.querySelector('.snack-bar-msg-top');
    if (!this.model.dinamicInput || !this.model.password) {
      if (type === LoginTypes.Simulator) {
        element.classList.add('js-margin-simulator');
        this.setSnackBar();
        this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG011, Constants.ALERT_TYPE.info);
      } else if (type === LoginTypes.Broker) {
        element.classList.add('js-margin-broker');
        this.setSnackBar();
        this._snackBar.createSnack(this.parent, Constants.MSG_LOGIN_MSG012, Constants.ALERT_TYPE.info);
      }
    }
  }

  setSnackBar() {
    const element = document.getElementById('snack-bar-msg');
    if (element) {
      element.classList.add('active');
      element.style.visibility = 'visible';
      setTimeout(() => {
        if (element) {
          if (element.classList.contains('active')) {
            element.classList.remove('active');
          }
        }
      }, 8000);
    }
  }

  redirecLogout() {
    this._configService.REDIRECT_LOGOUT();
  }

  callAlert(title, message, typeAlert) {
    this._configService.systemNotificationMessage(title, message, typeAlert);
  }

  getTermsUse() {
    const account = this._configService.getHbAccount();
    if (account) {
      this._authServer.iSuitabilityService.getTermsUse(account)
        .subscribe(res => {
          if (res && !res.error && res.data && res.data.length > 0) {
            const termsTemp = [];
            res.data.forEach((element) => {
              if (!element.is_signed) {
                termsTemp.push(element);
              }
            });
            if (termsTemp && termsTemp.length > 0) {
              this.openModalTerm(termsTemp, account);
            } else {
              this.redirectToHome();
            }
          } else {
            this.redirectToHome();
          }
        }, () => {
          this.redirectToHome();
        });
    } else {
      this._configService.systemNotificationMessage('', Constants.WORKSPACE_MSG021, Constants.ALERT_TYPE.error);
      this.onLoginError();
    }
  }

  openModalTerm(terms, account) {
    const messages = {
      title: Constants.WORKSPACE_MSG033,
      subTitle: Constants.WORKSPACE_MSG034,
      messageCheck: Constants.WORKSPACE_MSG035
    };
    const term = { type_term: Constants.TERM_OPERATOR_TYPES.URL, term: terms };
    const dialogConfig = this.dialog.open(TermOperatorModalComponent, {
      panelClass: Constants.TERM_OPERATOR_MODAL,
      width: '600px',
      data: { messages: messages, term: term, account: account },
      disableClose: true
    });
    dialogConfig.afterClosed().subscribe(res => {
      if (res) {
        this.postTermsUse(res);
      } else {
        this._configService.systemNotificationMessage('', Constants.WORKSPACE_MSG031, Constants.ALERT_TYPE.info);
        this.onLoginError();
      }
    });
  }

  postTermsUse(params) {
    if (params) {
      this._authServer.iSuitabilityService.postTermsUse(params)
        .subscribe(res => {
          if (res && res.error) {
            this._configService.systemNotificationMessage('', Constants.BROKER_MSG010, Constants.ALERT_TYPE.error);
          }
          this.redirectToHome();
        }, () => {
          this._configService.systemNotificationMessage('', Constants.BROKER_MSG010, Constants.ALERT_TYPE.error);
          this.redirectToHome();
        });
    } else {
      this._configService.systemNotificationMessage('', Constants.BROKER_MSG011, Constants.ALERT_TYPE.error);
      this.onLoginError();
    }
  }

}
